import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../contexts/TranslationContext';

const Header = () => {
  const { t, currentLanguage, changeLanguage, languages } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleLanguageDropdown = () => {
    setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
  };

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsLanguageDropdownOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };

  const currentLang = languages.find(lang => lang.code === currentLanguage);

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('.header');
      if (window.scrollY > 100) {
        header.style.background = 'rgba(255, 255, 255, 0.98)';
        header.style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.1)';
      } else {
        header.style.background = 'rgba(255, 255, 255, 0.95)';
        header.style.boxShadow = 'none';
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="header">
      <nav className="nav">
        <div className="nav-container">
          <div className="nav-logo">
            <Link to="/">Out of Box</Link>
          </div>
          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li>
              <a 
                href="#home" 
                className="nav-link" 
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('home');
                }}
              >
                {t('nav-home')}
              </a>
            </li>
            <li>
              <a 
                href="#services" 
                className="nav-link"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('services');
                }}
              >
                {t('nav-services')}
              </a>
            </li>
            <li>
              <a 
                href="#pricing" 
                className="nav-link"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('pricing');
                }}
              >
                {t('nav-pricing')}
              </a>
            </li>
            <li>
              <a 
                href="#contact" 
                className="nav-link"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('contact');
                }}
              >
                {t('nav-contact')}
              </a>
            </li>
            <li className="language-selector">
              <button 
                className={`language-btn ${isLanguageDropdownOpen ? 'active' : ''}`}
                onClick={toggleLanguageDropdown}
              >
                <span className="current-lang">
                  <img 
                    src={currentLang?.flag} 
                    alt={currentLanguage} 
                    style={{ width: '16px', height: '12px', borderRadius: '2px' }} 
                  />
                  <span style={{ fontWeight: '700', fontSize: '0.85em' }}>
                    {currentLanguage.toUpperCase()}
                  </span>
                </span>
                <i className="fas fa-chevron-down"></i>
              </button>
              <div className={`language-dropdown ${isLanguageDropdownOpen ? 'active' : ''}`}>
                {languages.map((language) => (
                  <a
                    key={language.code}
                    href="#"
                    className="language-option"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLanguageChange(language.code);
                    }}
                  >
                    <img src={language.flag} alt={language.code} className="lang-flag" />
                    <span className="lang-code">{language.code.toUpperCase()}</span>
                    <span className="lang-name">{language.name}</span>
                  </a>
                ))}
                <div className="translation-disclaimer">
                  <span>{t('translation-disclaimer')}</span>
                </div>
              </div>
            </li>
          </ul>
          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header; 